var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isGroup || _vm.isBuddies)?_c('core-filter-advanced-group',{attrs:{"title":"Members","count":_vm.count}},[_c('core-filter-input-suggest',{attrs:{"placeholder":"Start typing a name...","field":"name","filter":_vm.value('members'),"api":"users/suggest","data":"users"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }